export default __webpack_public_path__ + "f1051e3a095a599907aa6cebe8867bf0.svg";